import React, { useState, useRef, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Navbarfooter from "../Navbarfooter/index.js";
import Drawer from "../Drawer/index.js";
import NotificationBell from "../NotificationBell/index.js";
import UserMenuButton from "../UserMenuButton/index.js";
import logo from "../../images/logo.png";
import logoProf from "../../images/logo_prof.png";
import logoSmall from "../../images/logo_small.png";
import { ROLE_PROFESSOR } from "../../constants/roles";
import useUserMenu from "../../menus/useUserMenu";
import profMenu from "../../menus/prof_menu";
import ProfessorTopBar from "../../professor_platform/TopBar/index.js";
import TutoRunner from "../../tutos/TutoRunner.js";
import { updateUser } from "../../redux/authSlice";
import { getUserLeagueStatus } from "../../Api/authApi.js.js";

// ── Icônes sidebar (mêmes SVG que Navbarfooter)
function SidebarIcon({ name, active }) {
    const c = 'currentColor';
    switch (name) {
        case 'home':
            return <svg width={20} height={20} viewBox="0 0 22 22" fill="none"><path d="M3.5 9.5L11 3.5l7.5 6v8.5a1 1 0 01-1 1h-4v-6h-5v6h-4a1 1 0 01-1-1V9.5z" stroke={c} strokeWidth="1.6" strokeLinejoin="round" fill={active ? 'rgba(255,255,255,0.12)' : 'none'}/></svg>;
        case 'wallet':
            return <svg width={20} height={20} viewBox="0 0 22 22" fill="none"><rect x="3" y="6" width="16" height="12" rx="2.5" stroke={c} strokeWidth="1.6" fill={active ? 'rgba(255,255,255,0.12)' : 'none'}/><path d="M3 9.5h13a3 3 0 010 6H3" stroke={c} strokeWidth="1.6"/><circle cx="16" cy="12.5" r="1.1" fill={c}/></svg>;
        case 'markets':
            return <svg width={20} height={20} viewBox="0 0 22 22" fill="none"><path d="M3 14l4-5 3 3 4-7 5 9" stroke={c} strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round"/><path d="M3 18.5h16" stroke={c} strokeWidth="1.6" strokeLinecap="round"/></svg>;
        case 'trophy':
            return <svg width={20} height={20} viewBox="0 0 22 22" fill="none"><path d="M7 4h8v5a4 4 0 11-8 0V4z" stroke={c} strokeWidth="1.6" strokeLinejoin="round" fill={active ? 'rgba(255,255,255,0.12)' : 'none'}/><path d="M5 5H3v2a2 2 0 002 2M17 5h2v2a2 2 0 01-2 2M9 17h4M11 13v4" stroke={c} strokeWidth="1.6" strokeLinecap="round"/></svg>;
        case 'user':
            return <svg width={20} height={20} viewBox="0 0 22 22" fill="none"><circle cx="11" cy="8" r="3.5" stroke={c} strokeWidth="1.6" fill={active ? 'rgba(255,255,255,0.12)' : 'none'}/><path d="M4 19c0-3.6 3.1-6 7-6s7 2.4 7 6" stroke={c} strokeWidth="1.6" strokeLinecap="round"/></svg>;
        case 'teams':
            return <svg width={20} height={20} viewBox="0 0 22 22" fill="none"><circle cx="8" cy="8" r="3" stroke={c} strokeWidth="1.6" fill={active ? 'rgba(255,255,255,0.12)' : 'none'}/><circle cx="15" cy="9" r="2.4" stroke={c} strokeWidth="1.6" fill={active ? 'rgba(255,255,255,0.12)' : 'none'}/><path d="M3 18c0-3 2.2-5 5-5s5 2 5 5M14 18c0-2.2 1.5-4 4-4" stroke={c} strokeWidth="1.6" strokeLinecap="round"/></svg>;
        case 'video':
            return <svg width={20} height={20} viewBox="0 0 22 22" fill="none"><rect x="3" y="6" width="12" height="10" rx="2" stroke={c} strokeWidth="1.6" fill={active ? 'rgba(255,255,255,0.12)' : 'none'}/><path d="M15 9.5l4-2.5v8l-4-2.5" stroke={c} strokeWidth="1.6" strokeLinejoin="round"/></svg>;
        case 'document':
            return <svg width={20} height={20} viewBox="0 0 22 22" fill="none"><path d="M6 3h7l4 4v12a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z" stroke={c} strokeWidth="1.6" strokeLinejoin="round" fill={active ? 'rgba(255,255,255,0.12)' : 'none'}/><path d="M8 11h6M8 14.5h6" stroke={c} strokeWidth="1.4" strokeLinecap="round"/></svg>;
        case 'admin':
            return <svg width={20} height={20} viewBox="0 0 22 22" fill="none"><rect x="3" y="6" width="16" height="12" rx="2" stroke={c} strokeWidth="1.6" fill={active ? 'rgba(255,255,255,0.12)' : 'none'}/><path d="M3 9.5h16M7 6V4.5a1 1 0 011-1h6a1 1 0 011 1V6" stroke={c} strokeWidth="1.6"/></svg>;
        default:
            return <div style={{ width: 20, height: 20 }} />;
    }
}

const SIDEBAR_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
const SIDEBAR_DURATION = '0.25s';

function ToggleBtn({ onClick, collapsed, style = {} }) {
    return (
        <button
            onClick={onClick}
            title={collapsed ? 'Agrandir' : 'Réduire'}
            style={{
                width: 22, height: 22,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                borderRadius: 6,
                background: '#192033',
                border: '1px solid #202739',
                cursor: 'pointer', color: '#5C6B88',
                padding: 0,
                transition: 'background 0.15s, color 0.15s',
                ...style,
            }}
            onMouseEnter={e => { e.currentTarget.style.background = '#252C3D'; e.currentTarget.style.color = '#97A4BE'; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#192033'; e.currentTarget.style.color = '#5C6B88'; }}
        >
            <svg
                width={12} height={12} viewBox="0 0 16 16" fill="none"
                style={{ transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)', transition: `transform ${SIDEBAR_DURATION} ${SIDEBAR_EASING}` }}
            >
                <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </button>
    );
}

function DesktopSidebar() {
    const location = useLocation();
    const navigate = useNavigate();
    const role = useSelector((state) => state.auth.user?.role);
    const userMenu = useUserMenu();
    const menuLinks = role === ROLE_PROFESSOR ? profMenu : userMenu;
    const homePath = role === ROLE_PROFESSOR ? '/espace-professeur/vue-ensemble' : '/accueil';

    const [collapsed, setCollapsed] = useState(() => {
        try { return localStorage.getItem('sidebar-collapsed') === 'true'; } catch { return false; }
    });

    const toggle = () => {
        setCollapsed(c => {
            const next = !c;
            try { localStorage.setItem('sidebar-collapsed', String(next)); } catch {}
            return next;
        });
    };

    const w = collapsed ? 68 : 240;
    const labelStyle = {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: collapsed ? 0 : 200,
        opacity: collapsed ? 0 : 1,
        transition: `max-width ${SIDEBAR_DURATION} ${SIDEBAR_EASING}, opacity 0.15s ease`,
        flexShrink: 0,
    };

    return (
        // Wrapper sticky — zIndex:1 pour que son overflow soit au-dessus du contenu principal
        <div className="hidden lg:block" style={{
            width: w, minWidth: w, flexShrink: 0, height: '100vh',
            position: 'sticky', top: 0, zIndex: 1,
            transition: `width ${SIDEBAR_DURATION} ${SIDEBAR_EASING}, min-width ${SIDEBAR_DURATION} ${SIDEBAR_EASING}`,
        }}>
            {/* Inner : position:relative pour le bouton toggle absolu + flex-col pour le layout */}
            <div className="flex flex-col" style={{
                position: 'relative',
                height: '100%',
                background: 'rgba(255,255,255,0.02)',
                borderRight: '1px solid rgba(255,255,255,0.07)',
                padding: collapsed ? '28px 8px 24px' : '28px 16px 24px',
                overflow: 'visible',
                transition: `padding ${SIDEBAR_DURATION} ${SIDEBAR_EASING}`,
            }}>

                {/* Bouton toggle — absolu, glisse sur la bordure droite quand collapsed */}
                <ToggleBtn
                    onClick={toggle}
                    collapsed={collapsed}
                    style={{
                        position: 'absolute',
                        top: 32,
                        right: collapsed ? -11 : 12,
                        zIndex: 10,
                        transition: `right ${SIDEBAR_DURATION} ${SIDEBAR_EASING}, background 0.15s, color 0.15s`,
                    }}
                />

                {/* Logo (cliquable) */}
                <div
                    onClick={() => navigate(homePath)}
                    style={{
                        cursor: 'pointer', marginBottom: 36,
                        position: 'relative', height: 32,
                    }}
                >
                    {/* Logo plein — visible quand ouvert */}
                    <img
                        src={role === ROLE_PROFESSOR ? logoProf : logo}
                        alt="Trading Series"
                        style={{
                            height: 32, width: 'auto', display: 'block',
                            position: 'absolute', left: 0, top: 0,
                            opacity: collapsed ? 0 : 1,
                            transition: `opacity ${SIDEBAR_DURATION} ${SIDEBAR_EASING}`,
                            pointerEvents: 'none',
                        }}
                    />
                    {/* Logo réduit — visible quand collapsed */}
                    <img
                        src={logoSmall}
                        alt=""
                        style={{
                            height: 25, width: 'auto', display: 'block',
                            position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)',
                            opacity: collapsed ? 1 : 0,
                            transition: `opacity ${SIDEBAR_DURATION} ${SIDEBAR_EASING}`,
                            pointerEvents: 'none',
                        }}
                    />
                </div>

                {/* Nav links */}
                <nav style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4 }}>
                    {menuLinks.map(({ path, label, icon, isActive }) => {
                        const active = isActive(location.pathname);
                        return (
                            <button
                                key={path}
                                onClick={() => navigate(path)}
                                className={active ? 'bg-white/[0.08]' : 'hover:bg-black/[0.1]'}
                                style={{
                                    display: 'flex', alignItems: 'center',
                                    justifyContent: collapsed ? 'center' : 'flex-start',
                                    gap: collapsed ? 0 : 12,
                                    padding: '10px 12px',
                                    borderRadius: 10,
                                    border: 'none', cursor: 'pointer',
                                    color: active ? '#F2F5FB' : '#5C6B88',
                                    fontSize: 14, fontWeight: active ? 600 : 500,
                                    textAlign: 'left', overflow: 'hidden',
                                    transition: `background 0.15s, color 0.15s, gap ${SIDEBAR_DURATION} ${SIDEBAR_EASING}`,
                                }}
                            >
                                <SidebarIcon name={icon} active={active} />
                                <span style={labelStyle}>{label}</span>
                            </button>
                        );
                    })}
                </nav>

                {/* Profil / déconnexion */}
                <UserMenuButton collapsed={collapsed} />

            </div>
        </div>
    );
}

const Layout = () => {
    const role = useSelector((state) => state.auth.user?.role);
    const isProfessor = role === ROLE_PROFESSOR;
    const userId = useSelector((state) => state.auth.user?.id);
    const leagueArchived = useSelector((state) => state.auth.user?.league_archived);
    const dispatch = useDispatch();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isScrollingDown, setIsScrollingDown] = useState(false);
    const lastScrollY = useRef(0);
    const scrolledDown = useRef(0);
    const scrolledUp = useRef(0);

    const toggleDrawer = () => {
        const opening = !isDrawerOpen;
        setIsDrawerOpen(opening);
        if (opening) {
            setIsScrollingDown(false);
            scrolledDown.current = 0;
            scrolledUp.current = 0;
        }
    };

    // Le user est figé en localStorage depuis le login : on rafraîchit le statut de sa ligue
    // (elle a pu se terminer entre-temps) pour restreindre l'accès dès qu'elle est archivée.
    useEffect(() => {
        if (isProfessor || !userId) return;
        getUserLeagueStatus(userId)
            .then(({ league_archived }) => dispatch(updateUser({ league_archived: !!league_archived })))
            .catch(() => {});
    }, [userId, isProfessor, dispatch]);

    useEffect(() => {
        document.body.style.overflow = isDrawerOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [isDrawerOpen]);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY <= 0) {
                setIsScrollingDown(false);
                scrolledDown.current = 0;
                scrolledUp.current = 0;
                lastScrollY.current = 0;
                return;
            }

            const diff = currentScrollY - lastScrollY.current;

            if (diff > 0) {
                scrolledDown.current += diff;
                scrolledUp.current = 0;
                if (scrolledDown.current >= 60) setIsScrollingDown(true);
            } else if (diff < 0) {
                scrolledUp.current += Math.abs(diff);
                scrolledDown.current = 0;
                if (scrolledUp.current >= 50) setIsScrollingDown(false);
            }

            lastScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="min-h-screen flex" style={{ background: '#0A1226' }}>
            {/* Tutos d'onboarding par page — joueurs uniquement */}
            {!isProfessor && !leagueArchived && <TutoRunner />}

            {/* Cloche notifications desktop — fixed en haut à droite, cachée sur mobile/tablet et pour les professeurs */}
            {!isProfessor && (
                <div className="hidden lg:block">
                    <NotificationBell variant="desktop-fixed" />
                </div>
            )}

            {/* Sidebar desktop (caché sur mobile/tablet) */}
            <DesktopSidebar />

            {/* Colonne principale */}
            <div className="flex-1 min-w-0">
                {/* Header mobile/tablet — position fixed, hors du flux */}
                <Drawer toggleDrawer={toggleDrawer} isDrawerOpen={isDrawerOpen} isScrollingDown={isScrollingDown} />

                {/* Breadcrumb desktop — espace professeur uniquement, visible dès que la sidebar apparaît */}
                {isProfessor && <ProfessorTopBar />}

                {/* Contenu — margin-top mobile pour passer sous le header fixe */}
                <div className="lg:mt-0 mt-16">
                    <Outlet />
                </div>

                {/* Bottom nav mobile/tablet — position fixed, hors du flux */}
                <Navbarfooter />
            </div>
        </div>
    );
};

export default Layout;
